import { makeStyles } from "@material-ui/styles";

export const useDivisionStyles: any = makeStyles(
  (theme: { [key: string]: any }) => ({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },
    root1: {
      flexGrow: 1,
      position: "relative",
      overflowX: "auto",
    }
  })
);
